<template>
  <article class="empty-state">
    <i class="fal fa-comments icon"></i>
    <div class="cta">
      Ready to Create
      <br />
      a Direct Message?
    </div>
    <div class="subtitle">
      <ol>
        <li>Go to any Rally</li>
        <li>Click on a User's Avatar</li>
        <li>Create and send your Message</li>
        <li>The recipient will be notified</li>
      </ol>
    </div>
    Looking for your Messaging history?
    <div class="subtitle">
      (To see your complete list of messages, log into Rallyhood on your desktop or mobile browser)
    </div>
  </article>
</template>

<script>
  export default {
  }
</script>
